import {
  REQUEST_USERS_STATUS, RECEIVE_USERS_STATUS, REQUEST_USERS, RECEIVE_USERS, REQUEST_USER, RECEIVE_USER,
  REQUEST_REMOVE_USER, RECEIVE_REMOVE_USER, REQUEST_SAVE_USER, RECEIVE_SAVE_USER, REQUEST_CHANGE_PASSWD,
  RECEIVE_CHANGE_PASSWD, REQUEST_RECOVERY_PASSWORD, RECEIVE_RECOVERY_PASSWORD, REQUEST_CHANGE_EMAIL,
  RECEIVE_CHANGE_EMAIL, REQUEST_CHANGE_PHONE, RECEIVE_CHANGE_PHONE, REQUEST_RESET_PASSWD, RECEIVE_RESET_PASSWD,
  REQUEST_ADMIN_RESEND_EMAIL, RECEIVE_ADMIN_RESEND_EMAIL, REQUEST_USER_RESEND_EMAIL, RECEIVE_USER_RESEND_EMAIL,
  REQUEST_ACCEPT_TERMS, RECEIVE_ACCEPT_TERMS, RESET_USER, REQUEST_USERS_PACIENTE, RECEIVE_USERS_PACIENTE,
  REQUEST_USER_PACIENTE, RECEIVE_USER_PACIENTE, RESET_USER_PACIENTE, REQUEST_SAVE_USER_PACIENTE,
  RECEIVE_SAVE_USER_PACIENTE, REQUEST_NEW_PASSWD, RECEIVE_NEW_PASSWD, RESET_NEW_PASSWD, RESET_ALL_USERS,
  REQUEST_AUTENTICACAO_STATUS, RECEIVE_AUTENTICACAO_STATUS
 } from '../constants/ActionTypes'

const INITIAL_STATE = {
  status: {
    isLoading: false,
    data: {
      rows: [],
      count: 0
    },
    receivedAt: null,
  },
  statusAutenticacao: {
    isLoading: false,
    data: {
      rows: [],
      count: 0
    },
    receivedAt: null,
  },
  list: {
    isLoading: false,
    data: {
      rows: [],
      count: 0,
      page: 1,
      limit: 50,
    },
    receivedAt: null,
  },
  item: {
    isLoading: false,
    data: {},
    receivedAt: null,
  },
  listPaciente: {
    isLoading: false,
    data: {
      rows: [],
      count: 0,
      page: 1,
      limit: 50,
    },
    receivedAt: null,
  },
  itemPaciente: {
    isLoading: false,
    data: {},
    receivedAt: null,
  },
  saveItem: {
    isLoading: false,
  },
  saveItemPaciente: {
    isLoading: false,
  },
  newPasswd: {
    isLoading: false,
    password: null,
  },
  removeItem: {
    isLoading: false,
  },
  changePasswd: {
    isLoading: false,
  },
  changeEmail: {
    isLoading: false,
  },
  changePhone: {
    isLoading: false,
  },
  recoveryPassword: {
    isLoading: false,
  },
  resetPassword: {
    isLoading: false,
  },
  resendAdminEmail: {
    isLoading: false,
  },
  resendUserEmail: {
    isLoading: false,
  },
  acceptTerms: {
    isLoading: false,
  }
}

export default function UsersReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_USERS_STATUS.type:
      return {
        ...state,
        status: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.status.data,
        }
      }
    case RECEIVE_USERS_STATUS.type:
      return {
        ...state,
        status: {
          isLoading: action.isLoading,
          data: action.data,
          receivedAt: action.receivedAt,
        }
      }
    case REQUEST_AUTENTICACAO_STATUS.type:
      return {
        ...state,
        statusAutenticacao: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.statusAutenticacao.data,
        }
      }
    case RECEIVE_AUTENTICACAO_STATUS.type:
      return {
        ...state,
        statusAutenticacao: {
          isLoading: action.isLoading,
          data: action.data,
          receivedAt: action.receivedAt,
        }
      }
    case REQUEST_USERS.type:
        return {
          ...state,
          list: {
            isLoading: action.isLoading,
            data: INITIAL_STATE.list.data,
          }
        }
    case RECEIVE_USERS.type:
        return {
          ...state,
          list: {
            isLoading: action.isLoading,
            data: action.data,
            receivedAt: action.receivedAt,
          }
        }
    case REQUEST_USER.type:
      return {
        ...state,
        item: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.item.data,
        }
      }
    case RECEIVE_USER.type:
      return {
        ...state,
        item: {
          isLoading: action.isLoading,
          data: action.data,
          receivedAt: action.receivedAt,
        }
      }
    case REQUEST_SAVE_USER.type:
      return {
        ...state,
        saveItem: {
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_SAVE_USER.type:
      return {
        ...state,
        saveItem: {
          isLoading: action.isLoading,
        }
      }
    case REQUEST_REMOVE_USER.type:
      return {
        ...state,
        removeItem: {
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_REMOVE_USER.type:
      return {
        ...state,
        removeItem: {
          isLoading: action.isLoading,
        }
      }
    case REQUEST_CHANGE_PASSWD.type:
      return {
        ...state,
        changePasswd: {
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_CHANGE_PASSWD.type:
      return {
        ...state,
        changePasswd: {
          isLoading: action.isLoading,
        }
      }
    case REQUEST_CHANGE_EMAIL.type:
      return {
        ...state,
        changeEmail: {
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_CHANGE_EMAIL.type:
      return {
        ...state,
        changeEmail: {
          isLoading: action.isLoading,
        }
      }
    case REQUEST_CHANGE_PHONE.type:
      return {
        ...state,
        changePhone: {
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_CHANGE_PHONE.type:
      return {
        ...state,
        changePhone: {
          isLoading: action.isLoading,
        }
      }
    case REQUEST_RECOVERY_PASSWORD.type:
      return {
        ...state,
        recoveryPassword: {
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_RECOVERY_PASSWORD.type:
      return {
        ...state,
        recoveryPassword: {
          isLoading: action.isLoading,
        }
      }
    case REQUEST_RESET_PASSWD.type:
      return {
        ...state,
        resetPassword: {
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_RESET_PASSWD.type:
      return {
        ...state,
        resetPassword: {
          isLoading: action.isLoading,
        }
      }
    case REQUEST_ADMIN_RESEND_EMAIL.type:
      return {
        ...state,
        resendAdminEmail: {
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_ADMIN_RESEND_EMAIL.type:
      return {
        ...state,
        resendAdminEmail: {
          isLoading: action.isLoading,
        }
      }
    case REQUEST_USER_RESEND_EMAIL.type:
      return {
        ...state,
        resendUserEmail: {
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_USER_RESEND_EMAIL.type:
      return {
        ...state,
        resendUserEmail: {
          isLoading: action.isLoading,
        }
      }
    case REQUEST_ACCEPT_TERMS.type:
    case RECEIVE_ACCEPT_TERMS.type:
      return {
        ...state,
        acceptTerms: {
          isLoading: action.isLoading,
        }
      }
    case RESET_USER.type:
      return {
        ...state,
        item: INITIAL_STATE.item,
      }
    // user_paciente
    // -------------------------------------------------------------------------
    case REQUEST_USERS_PACIENTE:
        return {
          ...state,
          listPaciente: {
            isLoading: action.isLoading,
            data: INITIAL_STATE.listPaciente.data,
          }
        }
    case RECEIVE_USERS_PACIENTE:
        return {
          ...state,
          listPaciente: {
            isLoading: action.isLoading,
            data: action.data,
            receivedAt: action.receivedAt,
          }
        }
    case REQUEST_USER_PACIENTE:
      return {
        ...state,
        itemPaciente: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.itemPaciente.data,
        }
      }
    case RECEIVE_USER_PACIENTE:
      return {
        ...state,
        itemPaciente: {
          isLoading: action.isLoading,
          data: action.data,
          receivedAt: action.receivedAt,
        }
      }
    case REQUEST_SAVE_USER_PACIENTE:
      return {
        ...state,
        saveItemPaciente: {
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_SAVE_USER_PACIENTE:
      return {
        ...state,
        saveItemPaciente: {
          isLoading: action.isLoading,
        }
      }
    case REQUEST_NEW_PASSWD:
      return {
        ...state,
        newPasswd: {
          isLoading: action.isLoading,
          password: action.password,
        }
      }
    case RECEIVE_NEW_PASSWD:
      return {
        ...state,
        newPasswd: {
          isLoading: action.isLoading,
          password: action.password,
        }
      }
    case RESET_NEW_PASSWD:
      return {
        ...state,
        newPasswd: INITIAL_STATE.newPasswd,
      }
    case RESET_USER_PACIENTE:
      return {
        ...state,
        itemPaciente: INITIAL_STATE.itemPaciente,
      }
    case RESET_ALL_USERS.type:
      return INITIAL_STATE
    default:
      return state
  }
}
